import { render, staticRenderFns } from "./RenewalsOrderView.vue?vue&type=template&id=5e050264"
import script from "./RenewalsOrderView.vue?vue&type=script&lang=js"
export * from "./RenewalsOrderView.vue?vue&type=script&lang=js"
import style0 from "./RenewalsOrderView.vue?vue&type=style&index=0&id=5e050264&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports